<app-header (categorySelected)="onCategorySelected($event)"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-scroll-to-top></app-scroll-to-top>
<loader *ngIf="loaderService.isLoading | async"></loader>
